module.exports = __webpack_public_path__ + "media/sigreal.4b25c161.mp4";